import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';

import { sendResetPasswordEmail as sendResetPasswordEmailApi } from '../api/emails';

import { EMAIL_UNEXISTENT_ERROR_MESSAGE } from '../constants/messages';
import { GA_EVENTBRITE, GA_FACEBOOK, GA_APPLE } from '../constants/analytics';
import { FORGOT_PASSWORD_EMAIL_STATUSES } from '../constants/status';

import {
    trackPasswordForgotten,
    trackPasswordForgottenMailFailed,
    trackPasswordForgottenMailSent,
} from './gaTracking';

import { showAuthNotification, clearAuthNotification } from './auth';

/**  ACTION CREATORS  **/
export const SET_RESET_PASSWORD_EMAIL_STATUS =
    'SET_RESET_PASSWORD_EMAIL_STATUS';
export const setResetPasswordEmailStatus = (payload) => ({
    type: SET_RESET_PASSWORD_EMAIL_STATUS,
    payload,
});

/**  ACTIONS  **/
/**
 * this function should probably take the email as a parameter and the
 * component triggering it should know which email should it use
 */
export const sendResetPasswordEmail = ({
    sourceProvider = GA_EVENTBRITE,
    mustLinkAccount = false,
    email: formEmail,
}) => (dispatch, getState) => {
    const state = getState();

    const {
        authentication: {
            email,
            socialAuthenticationData: {
                apple: { email: _socialEmail } = {},
            } = {},
            socialAuthenticationData,
            socialData,
        } = {},
    } = state;

    const _email = formEmail || _socialEmail || email;

    if (!isUndefined(socialData?.sourceProvider)) {
        sourceProvider = GA_FACEBOOK;
    }
    if (!isEmpty(socialAuthenticationData?.apple)) {
        sourceProvider = GA_APPLE;
    }

    trackPasswordForgotten({
        sourceProvider,
        state,
    });

    dispatch(clearAuthNotification());
    dispatch(
        setResetPasswordEmailStatus(FORGOT_PASSWORD_EMAIL_STATUSES.ongoing),
    );

    return sendResetPasswordEmailApi(_email, mustLinkAccount, sourceProvider)
        .then(() => {
            dispatch(
                setResetPasswordEmailStatus(
                    FORGOT_PASSWORD_EMAIL_STATUSES.delivered,
                ),
            );
        })
        .then(() =>
            trackPasswordForgottenMailSent({
                sourceProvider,
                state,
            }),
        )
        .catch((error) => {
            dispatch(
                setResetPasswordEmailStatus(
                    FORGOT_PASSWORD_EMAIL_STATUSES.failed,
                ),
            );

            dispatch(
                showAuthNotification({
                    message: EMAIL_UNEXISTENT_ERROR_MESSAGE,
                }),
            );
            return trackPasswordForgottenMailFailed({
                errorMessage: get(
                    error,
                    'parsedError.error',
                    get(error, 'response.statusText', 'Error not defined'),
                ),
                state,
            });
        });
};
